import { Trans } from 'react-i18next';
import {
    StatusMapItem,
    StatusView,
    StatusViewProps,
} from 'src/components/StatusView/StatusView';
import { ApplicationStatus } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore.types';
import { CssColors } from 'src/styles/CssVariables';

type LoanApplicationStatusViewProps = Omit<
    StatusViewProps,
    'statusMap' | 'status'
> & {
    status?: StatusViewProps['status'];
};

export const LoanApplicationStatusView = ({
    status,
    ...props
}: LoanApplicationStatusViewProps) => {
    return status ? (
        <StatusView
            status={status}
            statusMap={loanApplicationStatusMap}
            {...props}
        />
    ) : null;
};

const loanApplicationStatusMap: StatusMapItem[] = [
    {
        status: ApplicationStatus.DECLINED,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.DECLINED" />
        ),
        color: CssColors.textWhite,
        backgroundColor: CssColors.red,
        borderColor: CssColors.red,
    },
    {
        status: ApplicationStatus.RETURNED_FOR_ASSIGNMENT,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.RETURNED_FOR_ASSIGNMENT" />
        ),
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: ApplicationStatus.ACTIVE,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.ACTIVE" />
        ),
        color: CssColors.textWhite,
        backgroundColor: CssColors.green,
        borderColor: CssColors.green,
    },
    {
        status: ApplicationStatus.ASSIGNED,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.ASSIGNED" />
        ),
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillWhite,
        borderColor: CssColors.borderMediumGrey,
    },
    {
        status: ApplicationStatus.FULLY_PAID,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.FULLY_REPAID" />
        ),
        color: CssColors.textWhite,
        backgroundColor: CssColors.pureBlack,
        borderColor: CssColors.pureBlack,
    },
    {
        status: ApplicationStatus.PENDING_ASSIGNMENT,
        label: (
            <Trans i18nKey="App.Component.LoanApplicationStatusView.PENDING_ASSIGNMENT" />
        ),
        color: CssColors.textBlack,
        backgroundColor: CssColors.fillGrey,
        borderColor: CssColors.borderMediumGrey,
    },
];
